module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-grey-1-22e075b7534c7c8b94c35e514d24cb18.png";